<template>
    <button @click="exportTransaction" class="btn btn-sm btn-info mr-1 mb-1">
        <i class="fa fa-download"></i>
        {{$t('export')}}
        <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
            <div class="alert alert-warning">
                <span>{{$t('exportNotice')}}</span>
            </div>
            <b-progress :max="totalCount">
                <b-progress-bar :value="downloadedCount" :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
            </b-progress>
        </b-modal>
    </button>
</template>

<script>
    import {saveAs} from 'file-saver';
    import Excel from 'exceljs';
    import moment from 'moment';

    export default {
        props: ['filter', 'totalCount'],
        data() {
            return {
                exporting: false,
                cancelRequest: false,
                downloadedCount: 0
            }
        },
        methods: {
            exportTransaction: async function () {
                this.exporting = true;
                let workbook = new Excel.Workbook();
                let sheet = workbook.addWorksheet('data');
                this.setupSheet(sheet);

                let response = null;
                let params = Object.assign({}, this.filter);
                params.page = 1;

                do {
                    if (this.cancelRequest) {
                        break;
                    }
                    let result = await this.$service.get('/credit-transaction/', {
                        params: params
                    });
                    params.page += 1;
                    response = result.data;
                    response.docs.forEach(item => {
                        let row = {
                            client: item.client && item.client.companyName ? item.client.companyName : 'unknown',
                            amount: item.amount,
                            balance: item.beforeBalance + item.amount,
                            content: item.content,
                            type: this.$t(item.type),
                            ref: item.ref,
                            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss')
                        };
                        sheet.addRow(row);
                        this.downloadedCount += 1;
                    });
                } while (response && response.hasNextPage);

                workbook.xlsx.writeBuffer({base64: true}).then(data => {
                    this.exporting = false;
                    saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                        'credit-transaction.xlsx');
                }).finally(() => {
                    this.cancelRequest = false;
                    this.downloadedCount = 0;
                });
            },
            setupSheet: function (sheet) {
                let cols = [
                    {header: this.$t('clientName'), key: 'client', width: 15},
                    {header: this.$t('amount'), key: 'amount', width: 10},
                    {header: this.$t('afterBalance'), key: 'balance', width: 15},
                    {header: this.$t('content'), key: 'content', width: 60},
                    {header: 'Ref', key: 'ref', width: 25},
                    {header: this.$t('transactionType'), key: 'type', width: 15},
                    {header: this.$t('time'), key: 'createTime', width: 15},
                ];
                sheet.columns = cols;
            },
            close() {
                this.cancelRequest = true;
            }
        },
        i18n: {
            messages: {
                vi: {
                    clientName: 'Tên khách hàng',
                    amount: 'Số tiền',
                    afterBalance: 'Số dư TK sau GD',
                    content: 'Nội dung giao dịch',
                    transactionType: 'Loại giao dịch',
                    time: 'Thời gian',
                    call: 'Cước gọi',
                    user:'Mua thêm người dùng',
                    new: 'Mua mới gói dịch vụ',
                    extend: 'Gia hạn dịch vụ',
                    upgrade: 'Nâng cấp dịch vụ',
                    number: 'Thuê số',
                    deposit: 'Nạp tiền',
                    gift: 'Tặng tiền',
                    exportNotice: 'Dữ liệu đang được tải xuống, vui lòng đợi trong giây lát!...',
                    export: 'Tải xuống',
                    exportingData: 'Xuất dữ liệu'
                },
                en: {
                    clientName: 'Client name',
                    amount: 'Amount',
                    afterBalance: 'Balance after transaction',
                    content: 'Content',
                    transactionType: 'Type',
                    time: 'Time',
                    call: 'Call fee',
                    user:'Buy more user',
                    new: 'Buy plan (first time)',
                    extend: 'Renew plan',
                    upgrade: 'Upgrade plan',
                    number: 'Rent phone number',
                    deposit: 'Deposit',
                    gift: 'Gift',
                    exportNotice: 'Data is being downloaded. Please wait for a few moment!...',
                    export: 'Export',
                    exportingData: 'Exporting data'
                },
            }
        }
    }
</script>
